import { sanityLanguage } from '@/constants/language';
import { GetAllCookiesQuery, useGetAllCookiesQuery } from './generated';

export type Cookie = NonNullable<NonNullable<GetAllCookiesQuery['allCookies']>[number]>;
export async function getAllCookies(): Promise<Cookie[]> {
	const fetchAllCookies = useGetAllCookiesQuery.fetcher({
		i18nLang: sanityLanguage,
	});

	const allCookies = await fetchAllCookies();

	return allCookies.allCookies;
}
